module.exports = __webpack_public_path__ + "static/media/elements2.ad8e56b5.png";